import React from "react"
import { Redirect, Switch } from "react-router-dom"
import { useSelector, shallowEqual } from "react-redux"
import { ContentRoute } from "../../layout"
import { InventoryPage } from "./inventory/InventoryPage"
import { MapInfrastructurePage } from "./map-infrastructure/MapInfrastructurePage"
import { Header } from "./header/Header"

export default function OperationsPage() {
	const { userClaims } = useSelector(
		state => ({
			userClaims: state.auth.claims
		}),
		shallowEqual
	)

	return (
		<div data-testid="operationsPage">
			<Header />
			<Switch>
				<Redirect exact={true} from="/operations" to="/operations/inventory" />

				{/* Inventory Page */}
				{userClaims?.isSuper && (
					<ContentRoute from="/operations/inventory" component={InventoryPage} />
				)}

				{userClaims?.isSuper && (
					<ContentRoute
						from="/operations/manage-infrastructure"
						component={MapInfrastructurePage}
					/>
				)}
			</Switch>
		</div>
	)
}
